/**
 * Tema white-label do app do comprador — CENTRALIZADO (nunca estilo inline
 * espalhado): a cor da incorporadora vira a CSS var --brand num único ponto,
 * e todas as telas consomem var(--brand) / var(--brand-soft). Sem cor
 * configurada, vale o verde padrão da AMA Capital.
 */
export const BRAND_PADRAO = '#0E7C5A';

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export function aplicarTema(el: HTMLElement, corMarca: string | null | undefined): void {
  const brand = corMarca && HEX_RE.test(corMarca) ? corMarca : BRAND_PADRAO;
  el.style.setProperty('--brand', brand);
  // Derivadas: tom suave para fundos de chip/ícone e tom profundo para o
  // gradiente do cartão hero. color-mix é CSS puro (sem JS de cor).
  el.style.setProperty('--brand-soft', `color-mix(in srgb, ${brand} 10%, white)`);
  el.style.setProperty('--brand-deep', `color-mix(in srgb, ${brand} 78%, black)`);
}
